import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["blockSize", "borderRadius", "inlineSize"];
import { AISkeleton } from 'ai-components-ui-library/components/loading/AISkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
const borderRadiusShapeMap = {
  'border-radius': 'rounded',
  'border-radius-xl': 'pill',
  'border-radius-full': 'circle'
};
export const BreezeSkeleton = _ref => {
  let {
      blockSize,
      borderRadius,
      inlineSize
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const shape = borderRadiusShapeMap[borderRadius];
  return /*#__PURE__*/_jsx(AISkeleton, Object.assign({}, rest, {
    height: blockSize,
    shape: shape,
    width: inlineSize
  }));
};